import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from '../../../services/analytics.service';
import { Router } from '@angular/router';
import { AuthGuard } from '../../../guard/auth.guard';
import { CatalogoMensaje } from '../../../constants/catalogo';
import { CONFIG } from '../../../constants/lottie.constants';
import { AnalyticsConstants } from '../../../constants/googleAnalytics';

@Component({
  selector: 'app-mensaje-exitoso',
  templateUrl: './mensaje-exitoso.component.html',
  styleUrls: ['./mensaje-exitoso.component.scss']
})
export class MensajeExitosoComponent implements OnInit {
  privacidad: string;
  condiciones: string;
  successmessage = CatalogoMensaje.successmessage;
  lottieInfo = CONFIG.SUCCESS;
  checkBoxIsClicked = false;
  previredIsCalled = true;
  buttonContinuar = {
    text: 'CONTINUAR',
    class: 'btn-primary',
    type: 'button'
  };
  buttonLlenarEess = {
    text: 'COMPLETAR ESTADO DE SITUACIÓN',
    class: 'btn-primary',
    type: 'button'
  };
  constructor(
    private readonly analyticsService: AnalyticsService,
    private readonly router: Router,
    private readonly authGuard: AuthGuard
  ) {
    this.authGuard.setActivated = false;
  }
  ngOnInit(): void {
    this.pageViewAnalytics('estado de situacion :: datos verificados');
  }

  callDirectiveEessPublico() {
    this.analyticsService.btnClick({
      label: 'completar estado de situacion',
      action: 'click',
      channel: AnalyticsConstants.chanel,
      element_id: undefined,
      type: 'button',
      section: 'exito'
    });
    this.authGuard.setActivated = true;
    this.router.navigate(['estado-situacion/edicion']);
  }
  callsuccessMessage() {
    this.previredIsCalled = false;
    this.btnClickAnalytics();
    this.pageViewAnalytics('estado de situacion :: autenticacion completada');
    this.endFlujoAnalytics();
  }
  buttonActivated(event) {
    this.checkBoxIsClicked = event.checked;
  }
  btnClickAnalytics() {
    this.analyticsService.btnClick({
      label: 'continuar',
      action: 'click',
      channel: AnalyticsConstants.chanel,
      element_id: undefined,
      type: 'button',
      section: 'exito'
    });
  }
  pageViewAnalytics(screenName: string) {
    this.analyticsService.pageView({
      screen_name: screenName
    });
  }
  endFlujoAnalytics() {
    this.analyticsService.endFlujo({
      label: 'felicidades has completado la autenticacion',
      action: 'enflujo',
      channel: AnalyticsConstants.chanel,
      element_id: undefined,
      type: undefined,
      section: 'exito',
      item_category: 'conversion',
      item_name: 'fin flujo autenticacion'
    });
  }
}
